const hungarian = {
    'STAFF_MANAGEMENT.Title_Point': "Bejelentkezési pont",
    'STAFF_MANAGEMENT.Title_Attendance': "Jelenlét",
    'STAFF_MANAGEMENT.UseLocation': "Saját hely használata",
    'STAFF_MANAGEMENT.SetPoint': "Bejelentkezési pont beállítása",
    'STAFF_MANAGEMENT.SetPointHelp': "Álljon oda, ahol a dolgozók bejelentkeznek, majd mentse el a helyét.",
    'STAFF_MANAGEMENT.CheckPin': "Ellenőrizze, hogy ez a megfelelő hely",
    'STAFF_MANAGEMENT.CheckSpot': "Ellenőrizze a jelölőt, majd mentse el",
    'STAFF_MANAGEMENT.Retake': "Újra",
    'STAFF_MANAGEMENT.Save': "Mentés",
    'STAFF_MANAGEMENT.Saving': "Mentés…",
    'STAFF_MANAGEMENT.Locating': "Pontosítjuk a helyét. Maradjon a bejelentkezési ponton — ez legfeljebb 15 másodpercig tarthat.",
    'STAFF_MANAGEMENT.LocationAccuracy': "Becsült pontosság: { accuracy } m",
    'STAFF_MANAGEMENT.LowAccuracyTitle': "Alacsony helymeghatározási pontosság",
    'STAFF_MANAGEMENT.LowAccuracyHelp': "Ellenőrizze a jelölőt, és szükség esetén helyezze át.",
    'STAFF_MANAGEMENT.LocationPermission': "Engedélyezze a helyadatokhoz való hozzáférést a böngésző beállításaiban, majd próbálja újra.",
    'STAFF_MANAGEMENT.LocationTimeout': "Nem sikerült időben meghatározni a helyét. Maradjon a bejelentkezési ponton, és próbálja újra.",
    'STAFF_MANAGEMENT.LocationUnavailable': "A helyadatai nem érhetők el. Ellenőrizze az eszköz helymeghatározási beállításait, és próbálja újra.",
    'STAFF_MANAGEMENT.MapUnavailable': "Nem sikerült betölteni a térképet. Próbálja újra.",
    'STAFF_MANAGEMENT.Ready': "Készen áll a bejelentkezésre",
    'STAFF_MANAGEMENT.UpdateLocation': "Hely frissítése",
    'STAFF_MANAGEMENT.ViewQr': "QR-kód megtekintése",
    'STAFF_MANAGEMENT.PointCreated': "Bejelentkezési pont beállítva",
    'STAFF_MANAGEMENT.PointUpdated': "Bejelentkezési pont frissítve",
    'STAFF_MANAGEMENT.SaveError': "Nem sikerült megerősíteni a mentést. Ellenőrizze a kapcsolatot, és próbálja újra.",
    'STAFF_MANAGEMENT.NoManageAccess': "Nincs jogosultsága beállítani vagy módosítani ezt a bejelentkezési pontot.",
    'STAFF_MANAGEMENT.NoAttendanceAccess': "Nincs jogosultsága megtekinteni a dolgozók jelenlétét.",
    'STAFF_MANAGEMENT.SelectExhibition': "Először válasszon rendezvényt.",
    'STAFF_MANAGEMENT.Loading': "Betöltés…",
    'STAFF_MANAGEMENT.Retry': "Újra",
    'STAFF_MANAGEMENT.Back': "Vissza",
    'STAFF_MANAGEMENT.QrTitle': "Bejelentkezési QR-kód",
    'STAFF_MANAGEMENT.QrMissing': "Még nem érhető el bejelentkezési QR-kód.",
    'STAFF_MANAGEMENT.QrError': "Nem sikerült betölteni a QR-kódot. Próbálja újra.",
    'STAFF_MANAGEMENT.GenerateQr': "QR-kód létrehozása",
    'STAFF_MANAGEMENT.GeneratingQr': "QR-kód létrehozása…",
    'STAFF_MANAGEMENT.QrGenerateError': "A pont mentése sikerült, de a QR-kódot nem sikerült létrehozni. Próbálja újra.",
    'STAFF_MANAGEMENT.DownloadPdf': "PDF letöltése",
    'STAFF_MANAGEMENT.PdfLoading': "PDF előkészítése…",
    'STAFF_MANAGEMENT.PdfError': "Nem sikerült létrehozni a PDF-et. Próbálja újra.",
    'STAFF_MANAGEMENT.Today': "Ma",
    'STAFF_MANAGEMENT.ChooseDate': "Dátum kiválasztása",
    'STAFF_MANAGEMENT.ChooseCompany': "Cég kiválasztása",
    'STAFF_MANAGEMENT.AllCompanies': "Összes cég",
    'STAFF_MANAGEMENT.Apply': "Alkalmaz",
    'STAFF_MANAGEMENT.NoCheckIn': "Nincs rögzített érkezés",
    'STAFF_MANAGEMENT.In': "Érkezés",
    'STAFF_MANAGEMENT.Out': "Távozás",
    'STAFF_MANAGEMENT.Working': "Dolgozik",
    'STAFF_MANAGEMENT.Completed': "Befejezve",
    'STAFF_MANAGEMENT.FailedCheckout': "Sikertelen kijelentkezés",
    'STAFF_MANAGEMENT.MissedCheckout': "Hiányzó kijelentkezés",
    'STAFF_MANAGEMENT.UnknownStatus': "Ismeretlen állapot",
    'STAFF_MANAGEMENT.NoAttendanceRecords': "Erre a napra nincs jelenléti bejegyzés.",
    'STAFF_MANAGEMENT.NoMatches': "Nincs a kiválasztott szűrőknek megfelelő dolgozó.",
    'STAFF_MANAGEMENT.AttendanceError': "Nem sikerült betölteni a jelenléti adatokat. Próbálja újra.",
    'STAFF_MANAGEMENT.UnknownCompany': "Nincs megadva cég",
    'STAFF_MANAGEMENT.LoadPointError': "Nem sikerült betölteni a bejelentkezési pontot. Próbálja újra.",
    'STAFF_MANAGEMENT.PosterTitle': "Bejelentkezés / Kijelentkezés",
    'STAFF_MANAGEMENT.PosterInstructions': "Nyissa meg az ELFE alkalmazást, és olvassa be ezt a QR-kódot a munka kezdetén és végén.",
    'STAFF_MANAGEMENT.PosterGenerated': "QR-kód létrehozva: { date }",
    'PHOTO_SOURCE.TakePhoto' : 'Fénykép készítése',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Kiválasztás a galériából',
    'CRAFT.Type_Logistics' : 'Logisztika { number }',
    'CRAFT.Type_Floor' : 'Padlózat { number }',
    'CRAFT.Type_Assembly' : 'Szerelés { number }',
    'CRAFT.Type_Electrics' : 'Villanyszerelés { number }',
    'CRAFT.Type_Graphic' : 'Grafika { number }',
    'CRAFT.Type_Furniture' : 'Bútorzat { number }',
    'CRAFT.Type_Multimedia' : 'Multimédia { number }',
    'CRAFT.Type_Cleaning' : 'Takarítás { number }',
    'CRAFT.Type_Additional' : 'Egyéb { number }',
    'CRAFT.Type_MPControl' : 'MP Control',
    'CRAFT.Type_Protocol' : 'Jegyzőkönyv',
    'CRAFT.Type_Service' : 'Szolgáltatás { number }',
    'CRAFT.Type_CollectGraphics' : 'Grafikák begyűjtése',
    'CRAFT.Status_Text_InProgress' : 'Folyamatban',
    'CRAFT.Status_Text_Disabled' : 'Letiltva',
    'CRAFT.Status_Text_Completed' : 'Befejezve',
    'CRAFT.Status_Text_Overdue' : 'Késésben',
    'CRAFT.Status_Text_Done' : 'Begyűjtve',
    'CRAFT.Status_Text_Open' : 'Nyitott',
    'CRAFT.Status_Text_Collected': 'Begyűjtve',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Az állapot nem módosítható: a grafikát már feldolgozták az adminisztrációs felületen',
    'CRAFT.Button_ViewAll' : 'Összes megtekintése',
    'CRAFT.Button_Text_Print' : 'Nyomtatás',
    'CRAFT.Button_Text_Stand' : 'Stand',
    'CRAFT.Button_Text_MarkOpen' : 'Szakág megjelölése nyitottként',
    'CRAFT.Button_Text_MarkDone' : 'Szakág megjelölése befejezettként',
    'CRAFT.Button_Text_MarkInProgress' : 'Szakág megjelölése folyamatban lévőként',
    'CRAFT.Button_ChangeStatus_InProgress' : 'Folyamatban',
    'CRAFT.Button_ChangeStatus_Done': 'Kész',
    'CRAFT.Button_Text_ShelfNumber' : 'Polcszám',
    'CRAFT.Filter_Params_CraftType' : 'Szakág: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Válasszon ki egy kiállítást { br } az alábbi listából',
    'EXHIBITION.Select_Label' : 'KIVÁLASZTOTT KIÁLLÍTÁS',
    'EXHIBITION.Modal_Title' : 'KIÁLLÍTÁS KIVÁLASZTÁSA',
    'EXHIBITION.Timer_State_Underway' : 'FOLYAMATBAN',
    'EXHIBITION.Timer_State_Ended' : 'VÉGET ÉRT',
    'EXHIBITION.Title_CraftTotal' : 'Összes szakág áttekintése',
    'EXHIBITION.Statistic_Status_InTotal' : 'összesen',
    'EXHIBITION.Statistic_Status_InProgress' : 'folyamatban',
    'EXHIBITION.Statistic_Status_Done' : 'kész',
    'EXHIBITION.Statistic_Status_Overdue' : 'késésben',
    'EXHIBITION.Statistic_Status_NotApproved' : 'nincs jóváhagyva',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'kiállításra beosztva',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Érkezés rögzítve',
    'EXHIBITION.Statistic_Type_Stands' : 'Standok',
    'EXHIBITION.Statistic_Type_Claims' : 'mp reklamációk',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Kiállítói reklamációk',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Last minute',
    'EXHIBITION.Statistic_Type_MpControl' : 'mp Control',
    'EXHIBITION.Statistic_Type_Damages' : 'Károk',
    'EXHIBITION.Statistic_Type_Protocol' : 'Jegyzőkönyv',
    'EXHIBITION.Statistic_Type_Staff' : 'Személyzet',
    'FORM.Textarea_Placeholder_JobDescription' : 'Feladat leírása*',
    'FORM.Button_Text_AddJob' : 'Feladat hozzáadása',
    'FORM.Button_Text_SaveJob' : 'Feladat mentése',
    'FORM.Button_AddJobPhoto' : 'Fénykép hozzáadása',
    'FORM_RULES.Required_Login' : 'Adja meg a felhasználónevét',
    'FORM_RULES.Required_Password' : 'Adja meg a jelszavát',
    'FORM_RULES.Required_KeyDescription' : 'Adja meg a kulcs leírását',
    'FORM_RULES.Required_KeyNumber' : 'Adja meg a kulcs számát',
    'FORM_RULES.Required_JobDescription' : 'Adja meg a feladat leírását',
    'FORM_RULES.Required_Quantity' : 'Adja meg a mennyiséget',
    'FORM_RULES.Min_Quantity' : 'A mennyiségnek legalább egynek kell lennie',
    'FORMS.Input_Label_Login' : 'felhasználónév',
    'FORMS.Input_Label_Password' : 'jelszó',
    'FORMS.Button_Text_Login' : 'Bejelentkezés',
    'FORMS.Input_Label_Description' : 'Leírás',
    'FORMS.Input_Label_KeyNumber' : 'Kulcsszám',
    'FORMS.Input_Label_Hall' : 'Csarnok',
    'FORMS.Input_Label_Stands' : 'Standok',
    'FORMS.Button_Text_ApplyFilters' : 'Alkalmazás',
    'FORMS.Button_Text_ResetFilters' : 'Szűrők visszaállítása',
    'FORMS.Select_DefaultValue_All' : 'Összes',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'Folyamatban lévő szakági munkákkal',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'Befejezett szakági munkákkal',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'Folyamatban lévő ellenőrzésekkel',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'Folyamatban lévő jegyzőkönyvezéssel',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'Késésben lévő szakági munkákkal',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'További feladatokkal',
    'FORMS.Button_Text_ApplySort' : 'Alkalmazás',
    'FORMS.Input_Label_CraftType' : 'Szakág típusa',
    'FORMS.Input_Label_JobType'   : 'Típus',
    'FORMS.Input_Label_JobFlag'   : 'Jelölés',
    'FORMS.Input_Label_JobStatus' : 'Állapot',
    'FORMS.Input_Label_CraftStatus' : 'Szakág állapota',
    'FORMS.Input_Label_DamageStatus' : 'Kár állapota',
    'FORMS.Input_Label_Subcontractor' : 'Alvállalkozó',
    'FORMS.Input_Label_Comments' : 'Hozzászólások',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Nyitott feladatok',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Folyamatban lévő feladatok',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Befejezett feladatok',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Jelölés nélkül',
    'FORMS.Select_JobFlag_WithFlag' : 'Jelöléssel',
    'FORMS.Input_Label_FurnishingName' : 'Berendezés neve',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Mennyiség',
    'FORMS.Input_Label_Quantity' : 'Mennyiség',
    'FORMS.Input_Label_CurrentQuantity' : 'Jelenlegi mennyiség',
    'FORMS.Input_Label_NewQuantity' : 'Új mennyiség',
    'FORMS.RadioInput_Text_Description' : 'Leírás',
    'FORMS.RadioInput_Text_Furnishing' : 'Berendezés',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Berendezés',
    'FORMS.Input_Label_OrderType'   : 'Típus',
    'FORMS.Select_FurnishingOrder_Type_Return' : 'Cikk visszavétele',
    'FORMS.Select_FurnishingOrder_Type_Lost' : 'Elveszett',
    'FORMS.Select_FurnishingOrder_Type_Correction' : 'Teljes mennyiség módosítása',
    'FORMS.Select_FurnishingOrder_Type_Order' : 'Rendelés',
    'GLOBAL.Button_Text_Logout' : 'Kijelentkezés',
    'GLOBAL.Button_Text_Filter' : 'Szűrés',
    'GLOBAL.Button_Text_Sort' : 'Rendezés',
    'GLOBAL.Text_Version' : 'Verzió: { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Mégse',
    'ATTENDANCE.Button_CheckIn': 'Érkezés',
    'ATTENDANCE.Button_CheckOut': 'Távozás',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Először válasszon ki egy kiállítást.',
    'ATTENDANCE.Button_RetryScan': 'Újraolvasás',
    'ATTENDANCE.Button_Close': 'Bezárás',
    'ATTENDANCE.Modal_Title_CheckIn': 'Kódolvasás az érkezés rögzítéséhez',
    'ATTENDANCE.Modal_Title_CheckOut': 'Kódolvasás a távozás rögzítéséhez',
    'ATTENDANCE.Scanner_Hint': 'Irányítsa a kamerát a QR-kódra',
    'ATTENDANCE.Processing_Locating_Title': 'Tartózkodási hely pontosítása…',
    'ATTENDANCE.Processing_Locating_Text': 'Kérjük, maradjon egy helyben. Ez akár 15 másodpercig is tarthat.',
    'ATTENDANCE.Processing_Submitting_Title': 'Beolvasott adatok küldése...',
    'ATTENDANCE.Processing_Submitting_Text': 'Kérjük, várjon. Jelenléti adatok mentése.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Hozzáférés szükséges a helyadatokhoz',
    'ATTENDANCE.Error_GpsPermission_Text': 'Engedélyezze a helyadatokhoz való hozzáférést a böngészőben, és próbálja újra.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Gyenge GPS-jel',
    'ATTENDANCE.Error_GpsTimeout_Text': 'A koordináták nem találhatók. Menjen közelebb a kijárathoz, és olvassa be újra a kódot.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'A GPS nem érhető el',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Ezen az eszközön nem érhetők el a helyadatok.',
    'ATTENDANCE.Error_Camera_Title': 'A kamera nem érhető el',
    'ATTENDANCE.Error_Camera_Text': 'Engedélyezze a kamerához való hozzáférést, és próbálja újra.',
    'ATTENDANCE.Error_CameraPermission_Title': 'A kamerához való hozzáférés le van tiltva',
    'ATTENDANCE.Error_CameraPermission_Text': 'Engedélyezze a kamerához való hozzáférést a böngésző webhelybeállításaiban, és próbálja újra.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Nem található kamera',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Ezen az eszközön nincs a böngésző számára elérhető kamera.',
    'ATTENDANCE.Error_SecureContext_Title': 'HTTPS szükséges',
    'ATTENDANCE.Error_SecureContext_Text': 'A kamera és a GPS mobilböngészőkben csak HTTPS-kapcsolaton keresztül működik. Nyissa meg az alkalmazást HTTPS-alapú fejlesztői alagúton keresztül.',
    'ATTENDANCE.Error_Server_Title': 'Sikertelen kódolvasás',
    'ATTENDANCE.Error_Server_Text': 'A szerver nem dolgozta fel a beolvasott adatokat. Ellenőrizze az internetkapcsolatát, és próbálja újra.',
    'ATTENDANCE.Error_Generic_Title': 'Sikertelen kódolvasás',
    'ATTENDANCE.Error_Generic_Text': 'Kérjük, próbálja újra.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Érkezés sikeresen rögzítve',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Távozás sikeresen rögzítve',
    'ATTENDANCE.Result_Accepted_Text': 'Időpont: { serverTime }. A rendszer rögzítette az adatokat.',
    'ATTENDANCE.Result_Duplicate_Title': 'Már rögzítve',
    'ATTENDANCE.Result_Duplicate_Text': 'Ezt a kódolvasást már elmentettük.',
    'ATTENDANCE.Result_OpenSessionElsewhere_Title': 'Érkezés rögzítve egy másik kiállításon',
    'ATTENDANCE.Result_OpenSessionElsewhere_Text': 'Előbb rögzítse ott a távozását, és csak utána rögzítse itt az érkezését. Ha nem fér hozzá ahhoz a kiállításhoz, forduljon az építésvezetőhöz vagy a projektvezetőhöz.',
    'ATTENDANCE.Result_ShiftClosed_Title': 'A műszak már le van zárva',
    'ATTENDANCE.Link_MyTimeRecords': 'Saját munkaidőadataim megtekintése',
    'ATTENDANCE.Result_ShiftClosed_Text': 'A műszakja már le van zárva. Ha nem Ön rögzítette a távozását, lehet, hogy egy vezető zárta le a műszakját. Új műszak kezdéséhez rögzítse az érkezését.',
    'ATTENDANCE.Result_AlreadyCheckedIn_Title': 'Érkezés már rögzítve',
    'ATTENDANCE.Result_AlreadyCheckedIn_Text': 'Az érkezés újbóli rögzítése előtt rögzítse a távozását erről a kiállításról.',
    'ATTENDANCE.Result_Rejected_Title': 'Hozzáférés elutasítva',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Túl messze van a bejárattól. Menjen közelebb a bejárathoz.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Ez a QR-kód nem érvényes az érkezés vagy a távozás rögzítéséhez.',
    'ATTENDANCE.Result_GenericRejected_Text': 'A kódolvasás elutasítva.',
    'ATTENDANCE.Button_Back': 'Vissza',
    'ATTENDANCE.Button_TryAgain': 'Újrapróbálkozás',
    'ATTENDANCE.Button_GotIt': 'Értem',
    'ATTENDANCE.Overview_NotCheckedIn': 'Érkezés nincs rögzítve',
    'ATTENDANCE.Overview_CheckInPrompt': 'Rögzítse az érkezését{ br }a QR-kód beolvasásával',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Érkezése rögzítve',
    'ATTENDANCE.Overview_CheckedInAt': '{ time }-kor',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'A munka megkezdése előtt olvassa be a QR-kódot az érkezés rögzítéséhez',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'A távozás rögzítéséhez irányítsa a kamerát a kiállításon található QR-kódra',
    'ATTENDANCE.Error_StatusLoad_Text': 'Az érkezés állapotát nem sikerült betölteni.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Az alkalmazás nem tudja megnyitni a kamerát',
    'ATTENDANCE.Error_CameraDesign_Text': 'Az érkezés rögzítéséhez olvassa be a kódot a telefon kamerájával. Koppintson az Újrapróbálkozás gombra, majd engedélyezze a kamera használatát, amikor a telefon kéri.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Továbbra sem működik? Lehet, hogy letiltotta a kamerát. Ellenőrizze a böngésző engedélyeit.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Az alkalmazás nem látja az Ön helyzetét',
    'ATTENDANCE.Error_LocationDesign_Text': 'Az érkezés rögzítéséhez helyadatok szükségesek annak ellenőrzésére, hogy a helyszínen van-e. Kapcsolja be a helymeghatározást a telefon beállításaiban, majd koppintson az Újrapróbálkozás gombra.',
    'ATTENDANCE.Result_CheckedInAt': 'Érkezés rögzítve: { date }, { time }',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Munkába érkezése sikeresen rögzítve { time }-kor.',
    'ATTENDANCE.Result_CheckedOutAt': 'Befejezte a munkát,{ br }távozása rögzítve { time }-kor',
    'ATTENDANCE.Result_OutsideRadius_Title': 'A helyszínen kell tartózkodnia',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Az Ön helyzete nem egyezik a kiállítás helyszínével. Az érkezés rögzítése GPS-adatok alapján történik. Olvassa be újra a kódot, amikor a megfelelő helyen tartózkodik.',
    'ATTENDANCE.Result_LowAccuracy_Title': 'Alacsony helymeghatározási pontosság',
    'ATTENDANCE.Result_LowAccuracy_Badge': 'Pontosság: { accuracy } (Túl alacsony)',
    'ATTENDANCE.Result_LowAccuracy_CheckIn': 'Az érkezés rögzítéséhez:',
    'ATTENDANCE.Result_LowAccuracy_CheckOut': 'A távozás rögzítéséhez:',
    'ATTENDANCE.Result_LowAccuracy_PreciseLocation': 'Engedélyezze a „Pontos helyzet” használatát a böngészőnek a telefon beállításaiban',
    'ATTENDANCE.Result_LowAccuracy_Wifi': 'Kapcsolja be a Wi-Fi-t, hogy segítse az eszköz helyének meghatározását',
    'ATTENDANCE.Result_LowAccuracy_Retry': 'Ezután koppintson a { back } gombra, és olvassa be újra a kódot.',
    'ATTENDANCE.Accuracy_Meters': '{ value } m',
    'ATTENDANCE.Accuracy_Kilometers': '{ value } km',
    'ATTENDANCE.Result_InvalidQr_Title': 'Ez nem a megfelelő kód',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Az érkezés nem rögzíthető!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'A távozás nem rögzíthető!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Ez a QR-kód nem az Ön rendezvényéhez tartozik. Kérjük, forduljon az építésvezetőhöz vagy a projektvezetőhöz.',
    'ATTENDANCE.Result_OutdatedQr_Text': 'Ez a QR-kód elavult. Kérjük, olvassa be a legújabb QR-kódot.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Az érkezés nem rögzíthető!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Ezzel a telefonnal már rögzítették egy másik személy érkezését. Az alkalmazás nem engedi, hogy két különböző felhasználó ugyanazzal az eszközzel rögzítse az érkezését!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Az érkezés rögzítéséhez szükséges kódolvasás nem lehetséges!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Az érkezés csak a rendezvény meghatározott időszakában rögzíthető. Kérjük, forduljon az építésvezetőhöz vagy a projektvezetőhöz.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'A távozás most nem rögzíthető',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Ez a művelet csak a kiállítás beállított időszakában érhető el. Ellenőrizze a kiválasztott kiállítást és annak időpontjait.',
    'ATTENDANCE.TimeRecords_InProgress': 'folyamatban',
    'ATTENDANCE.TimeRecords_Missed': 'hiányzik',
    'ATTENDANCE.TimeRecords_Empty': 'Még nincsenek munkaidőadatok.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'A munkaidőadatokat nem sikerült betölteni.',
    'MENUS.Label_MyTimeRecords': 'Saját munkaidőadataim',
    'PAGE.Title_MyTimeRecords': 'Saját munkaidőadataim',
    'GLOBAL.Badge_Text_New' : 'ÚJ',
    'GLOBAL.Modal_Title_Filters' : 'Szűrők',
    'GLOBAL.Modal_Title_SortBy' : 'Rendezés',
    'GLOBAL.TimeLeft' : '{ timeLeft } van hátra',
    'GLOBAL.Text_Piece' : 'db',
    'GLOBAL.Button_Text_Confirm' : 'Megerősítés',
    'GLOBAL.Language_Default' : 'Alapértelmezett',
    'TRANSLATION.Button_Text_Translate' : 'Fordítás',
    'TRANSLATION.Button_Text_TranslateInput' : 'Fordítás németre',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Fordítás angolra',
    'TRANSLATION.Button_Text_TranslateNative' : 'Fordítás a saját nyelvemre',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Eredeti német szöveg megjelenítése',
    'TRANSLATION.Text_InputTranslating' : 'Fordítás folyamatban...',
    'TRANSLATION.Text_InputTranslated' : 'Lefordítva',
    'TRANSLATION.Text_InputTranslationError' : 'Sikertelen fordítás',
    'TRANSLATION.Text_InputTranslationRequired' : 'Küldés előtt fordítsa le a szöveget',
    'TRANSLATION.Text_ApiUnavailable' : 'A fordítás jelenleg nem érhető el',
    'GLOBAL.Card_Hero_Hall' : 'Csarnok',
    'GLOBAL.Card_Hero_Block' : 'Blokk',
    'GLOBAL.Card_Hero_Stand' : 'Stand',
    'GLOBAL.Comment': 'Hozzászólás',
    'HALL.Button_Text_HallPlan' : 'Csarnoktérkép',
    'HALL.Link_Text_HallPlan' : '{ hallName } csarnoktérképe',
    'JOB.Tag_Claim' : 'R',
    'JOB.Tag_CustomerClaim' : 'R',
    'JOB.Tag_MPAndCustomerClaim' : 'R',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'K',
    'JOB.Tag_ProtocolDefect' : 'JH',
    'JOB.Card_Hero_Hall' : 'Csarnok',
    'JOB.Card_Hero_Number' : 'Feladatszám',
    'JOB.Card_Hero_Block' : 'Blokk',
    'JOB.Card_Hero_Stand' : 'Stand',
    'JOB.Card_Hero_Exhibitor' : 'Kiállító',
    'JOB.Button_Text_ToTheStand' : 'A standhoz',
    'JOB.Text_Creator' : '{ whoCreate }, { whenCreate }',
    'JOB.Text_InWork' : '{ whoWork }, { whenWork }',
    'JOB.Text_Executor' : '{ whoExecute }, { whenExecute }',
    'JOB.Text_DurationTime' : 'Időtartam: { time }',
    'JOB.Type_Claim' : 'mp reklamáció',
    'JOB.Type_AllClaims' : 'Reklamáció',
    'JOB.Type_CustomerClaim' : 'Kiállítói reklamáció',
    'JOB.Type_LastMinute' : 'Last minute',
    'JOB.Type_Damage' : 'Kár',
    'JOB.Type_ProtocolDefect' : 'Jegyzőkönyvezett hiba',
    'JOB.Button_ChangeStatus_Waiting' : 'Feladat elvállalása',
    'JOB.Button_ChangeStatus_InProgress' : 'Feladat folyamatban',
    'JOB.Button_ChangeStatus_Done' : 'Feladat befejezése',
    'JOB.Modal_Title_Photo' : 'Feladat fényképe',
    'JOB.Filter_Params_JobType' : 'Típus: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Szakág: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Új { jobType }',
    'JOB.Modal_Title_EditJob' : '{ jobType } szerkesztése',
    'JOB.Button_Text_AddClaim' : 'mp reklamációs feladat hozzáadása',
    'JOB.Button_Text_AddCustomerClaim' : 'Kiállítói reklamációs feladat hozzáadása',
    'JOB.Button_Text_AddLastMinute' : 'Last minute feladat hozzáadása',
    'JOB.Button_Text_AddDamage' : 'Kárfotó hozzáadása',
    'JOB.Button_Text_AddProtocolDefect' : 'Jegyzőkönyvezett hiba hozzáadása',
    'DAMAGE.Card_Title' : '{ exhibitor } kárai',
    'DAMAGE.Modal_Title_Photo' : '{ exhibitor } kárai',
    'DAMAGE.Status_Label_New' : 'Ellenőrizetlen',
    'DAMAGE.Status_Label_Check' : 'Ellenőrizve',
    'DAMAGE.Status_Label_DCheck' : 'Jóváhagyva',
    'DAMAGE.Button_Text_Stand' : 'Stand',
    'DAMAGE.Button_Text_Photo' : 'Fénykép',
    'DAMAGE.Button_Text_AddNote' : 'MEGJEGYZÉS HOZZÁADÁSA',
    'DAMAGE.Modal_Button_AddPhoto' : 'Fénykép hozzáadása',
    'DAMAGE.Modal_Button_CreateReport' : 'Jelentés létrehozása',
    'DAMAGE.Modal_Button_EditReport' : 'Jelentés szerkesztése',
    'DAMAGE.AsCraft_label' : 'Károk',
    'DAMAGE.Button_Text_Open' : 'Megnyitás',
    'STAND.Block_Title_Damages' : 'Károk',
    'MENUS.Label_Overview' : 'Áttekintés',
    'MENUS.Label_Stands' : 'Standok',
    'MENUS.Label_Jobs' : 'Feladatok',
    'MENUS.Label_ExpoPlan' : 'Kiállítási térkép',
    'MENUS.Label_More' : 'Továbbiak',
    'MENUS.Label_SelectExhibition' : 'Kiállítás kiválasztása',
    'MENUS.Label_CraftsOverview' : 'Szakágak áttekintése',
    'MENUS.Label_HallsOverview' : 'Csarnokok áttekintése',
    'MENUS.Label_ViewDamages' : 'Károk megtekintése',
    'MENUS.Label_Downloads' : 'Letöltések',
    'MENUS.Label_Documents' : 'Dokumentumok',
    'MENUS.Label_FurnishingLeftovers' : 'Megmaradt berendezések',
    'MENUS.Label_HelpImprint' : 'Impresszum',
    'MENUS.Label_CollectGraphics' : 'Grafikák begyűjtése',
    'NO_DATA.Exhibitions' : 'Még nincsenek kiállításai.',
    'NO_DATA.Documents' : 'Ehhez a kiállításhoz { br } még nincsenek dokumentumok.',
    'NO_DATA.Stands' : 'A keresésnek megfelelő standok { br } nem találhatók',
    'NO_DATA.StandPhoto' : 'Még nincs fénykép a standról',
    'NO_DATA.DamagePhoto' : 'Még nincs fénykép { br } a stand kárairól',
    'NO_DATA.Stand_NoKeys' : 'Ehhez a standhoz még nincsenek kulcsok',
    'NO_DATA.Stand_DoesNotExist' : 'Ez a stand nem létezik',
    'NO_DATA.Subcontractor_Unsigned' : 'Nincs hozzárendelve',
    'NO_DATA.Jobs' : 'A keresésnek megfelelő feladatok { br } nem találhatók',
    'NO_DATA.Damages' : 'A keresésnek megfelelő károk { br } nem találhatók',
    'NO_DATA.Hall' : 'Ez a csarnok nem létezik',
    'NO_DATA.HallPlan' : 'Nem található térkép ehhez a csarnokhoz',
    'NO_DATA.Furnishing_Storage' : 'Ehhez a kiállításhoz { br } nincsenek berendezések raktáron',
    'NO_DATA.Furnishing_Orders' : 'Ehhez a kiállításhoz { br } nincsenek berendezésrendelések',
    'PAGE.Title_Overview' : 'Áttekintés',
    'PAGE.Title_ExhibitionSelection' : 'Kiállítás kiválasztása',
    'PAGE.Title_Stands' : 'Standok',
    'PAGE.Title_Stand' : 'Stand',
    'PAGE.Title_StandComments' : 'Standhoz tartozó hozzászólások',
    'PAGE.Title_StandLog' : 'Standnapló',
    'PAGE.Title_StandKeys' : 'Standkulcsok',
    'PAGE.Title_ViewDamages' : 'Károk megtekintése',
    'PAGE.Title_AdditionalMenu' : 'További menüpontok',
    'PAGE.Title_Jobs' : 'Feladatok',
    'PAGE.Title_ExpoPlan' : 'Kiállítási térkép',
    'PAGE.Title_Documents' : 'Dokumentumok',
    'PAGE.Title_FurnishingLeftovers' : 'LM berendezések',
    'PAGE.Title_FurnishingReturns' : 'Berendezések változásnaplója',
    'PAGE.Title_HallPlan' : 'Csarnoktérkép',
    'PAGE.Title_HallsOverview' : 'Csarnokok áttekintése',
    'PAGE.Title_CraftsOverview' : 'Szakágak áttekintése',
    'PAGE.Title_HelpImprint' : 'Impresszum',
    'PAGE.Title_CollectGraphics' : 'Grafikák begyűjtése',
    'SORT.Text_NewestByCreation' : 'Legújabbak létrehozás szerint',
    'SORT.Text_OldestByCreation' : 'Legrégebbiek létrehozás szerint',
    'SORT.Text_ExhibitorNameAZ' : 'Kiállító neve (A–Z)',
    'SORT.Text_ExhibitorNameZA' : 'Kiállító neve (Z–A)',
    'SORT.Text_FinishedFirst' : 'Befejezettek elöl',
    'SORT.Text_InProgressFirst' : 'Nyitottak elöl',
    'SORT.Text_StandNumberAZ' : 'Standszám (A–Z)',
    'SORT.Text_StandNumberZA' : 'Standszám (Z–A)',
    'SORT.Text_CorridorAZ' : 'Folyosó (A–Z)',
    'SORT.Text_CorridorZA' : 'Folyosó (Z–A)',
    'SORT.Text_BlockAZ' : 'Blokk (A–Z)',
    'SORT.Text_BlockZA' : 'Blokk (Z–A)',
    'SORT.Text_FlagFirst' : 'Megjelöltek elöl',
    'SORT.Text_FlagLast' : 'Megjelöltek hátul',
    'SORT.Text_HallAZ' : 'Csarnok (A–Z)',
    'SORT.Text_HallZA' : 'Csarnok (Z–A)',
    'SORT.Text_StatusAZ' : 'Jóváhagyva',
    'SORT.Text_StatusZA' : 'Ellenőrizetlen',
    'STAND.Modal_Title_Search' : 'Keresés',
    'STAND.Input_Placeholder_Search' : 'Keresés',
    'STAND.Filter_Params_Exhibitor' : 'Kiállító: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'Hozzászólásokkal',
    'STAND.Card_Hero_Hall' : 'Csarnok',
    'STAND.Card_Hero_Block' : 'Blokk',
    'STAND.Card_Hero_Stand' : 'Stand',
    'STAND.Card_Hero_DeliveryTime' : 'Határidő',
    'STAND.Modal_Title_StandPlan' : 'Standrajz',
    'STAND.Modal_Button_StandPlan' : 'Rajz',
    'STAND.Card_Button_Details' : 'Részletek { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Standfotó',
    'STAND.Modal_Button_StandPhoto' : 'Fénykép',
    'STAND.Modal_Button_SavePhoto' : 'Fénykép mentése',
    'STAND.Modal_Button_AddPhoto' : 'Fénykép hozzáadása',
    'STAND.Button_Text_Comments' : 'Hozzászólások',
    'STAND.Button_Text_AddComment' : 'Hozzászólás hozzáadása',
    'STAND.Modal_Title_AddComment' : 'Hozzászólás hozzáadása',
    'STAND.Modal_Title_EditComment' : 'Hozzászólás szerkesztése',
    'STAND.Modal_Button_AddComment' : 'Hozzáadás',
    'STAND.Modal_Button_SaveComment' : 'Mentés',
    'STAND.Text_NoComments' : 'Még nincsenek hozzászólások',
    'STAND.Text_AddFile' : 'Fájl hozzáadása',
    'COMMENTS.Text_Uploading' : 'Feltöltés...',
    'STAND.Text_EditComment' : 'Szerkesztés',
    'STAND.Text_DeleteComment' : 'Törlés',
    'STAND.Text_CommentDraftError' : 'A hozzászólás piszkozata még nem áll készen',
    'STAND.Block_Title_Overview' : 'Áttekintés',
    'STAND.Block_Title_Materials' : 'További információk',
    'STAND.Block_Title_Crafts' : 'Szakágak',
    'STAND.Block_ItemTitle_Hall' : 'Csarnok',
    'STAND.Block_ItemTitle_Block' : 'Blokk',
    'STAND.Block_ItemTitle_Stand' : 'Stand',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Proauf-szám',
    'STAND.Block_ItemTitle_Jobs' : 'Feladatok',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } folyamatban',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } nyitott',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } befejezett',
    'STAND.Block_Button_ViewStandJobs' : 'Stand feladatainak megtekintése',
    'STAND.Modal_Title_StandGraphic' : 'Standgrafika',
    'STAND.Modal_Button_StandGraphic' : 'Standgrafika',
    'STAND.Modal_Title_ExtraInfo' : 'További információk',
    'STAND.Modal_Button_ExtraInfo' : 'További információk',
    'STAND.Button_Text_ViewKeys' : 'Kulcsok megtekintése',
    'STAND.Button_Text_ViewLogs' : 'Napló megtekintése',
    'STAND.Modal_Button_AddKey' : 'Kulcs hozzáadása',
    'STAND.Modal_Title_AddKey' : 'Kulcs hozzáadása',
    'STAND.Modal_Title_EditKey' : 'Kulcs szerkesztése',
    'STAND.Modal_Button_UpdateKey' : 'Kulcs frissítése',
    'STAND.Filter_Params_Stand' : 'Stand { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Törlés',
    'STAND.Text_ModalDelete_Question' : 'Biztosan törli a következő kulcsot: { keyName }?',
    'STAND.External_Exhibition' : 'Kiállítás, amelyhez nincs hozzárendelve',
    'JOB.Button_Text_ViewPhoto' : 'Fénykép megtekintése',
    'OVERVIEW_TYPES.Label_InTotal' : 'összesen',
    'OVERVIEW_TYPES.Label_Finished' : 'befejezett',
    'OVERVIEW_TYPES.Label_Open' : 'nyitott',
    'OVERVIEW_TYPES.Label_Claims' : 'reklamációk',
    'OVERVIEW_TYPES.Label_LastMinute' : 'last min',
    'OVERVIEW_TYPES.Label_Overdue' : 'késésben',
    'FURNISHING.TabName_Storage' : 'Raktár',
    'FURNISHING.TabName_Refund' : 'Visszavételek',
    'FURNISHING.TabName_OrderLog' : 'Rendelési napló',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'LM berendezések mennyisége',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Raktáron lévő berendezések',
    'FURNISHING.Button_Text_Return' : 'Visszavétel',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Berendezés kiválasztása',
    'FURNISHING.Modal_Title_Photo' : 'Berendezés fényképe',
    'FURNISHING.Order_Type_Refund' : 'Visszavétel',
    'FURNISHING.Order_Type_Lost' : 'Elveszett',
    'FURNISHING.Order_Type_Correction' : 'Korrekció',
    'FURNISHING.Order_Type_Order' : 'Rendelés',
};

export default hungarian;
